/*
 * Decléor — richtext block behaviour
 * ---------------------------------------------------------------------------
 * The ONLY script the four new section-richtext blocks need, and it does exactly one thing:
 * mirror the before/after slider's native <input type="range"> value onto the frame's
 * --dc-cmp-pos custom property, which drives the clip-path in richtext-blocks-style.liquid.
 *
 * Everything else those blocks do is CSS or the theme's own AOS pipeline:
 *   - ritual reveals    → data-aos / data-aos-order (theme.js), so reduced-motion and the
 *                         merchant's scroll-animation toggle already govern them,
 *   - ingredient cards  → pure CSS flex,
 *   - pull quote        → pure CSS.
 *
 * WHY THERE IS NO POINTER CODE HERE. The comparison control is a real range input laid
 * transparently over the frame, so drag, click-to-jump, touch, pen, keyboard (arrows / Home /
 * End) and assistive-tech labelling are all native browser behaviour. Hand-rolling pointerdown/
 * pointermove would mean reimplementing every one of those, worse. The one thing the platform
 * cannot do is push the value into CSS — that is this file.
 *
 * Delegated from the document, so blocks that arrive later (theme editor re-render, Section
 * Rendering API) work with no re-initialisation. No-ops on any page without a
 * [data-dc-comparison]. Degrades to a static split at the merchant's start position if it
 * never runs, because that position is written inline as --dc-cmp-pos in Liquid.
 */
(function () {
  'use strict';

  var FRAME = '[data-dc-comparison]';

  function sync(input) {
    var frame = input.closest ? input.closest(FRAME) : null;
    if (!frame) { return; }
    // Clamp defensively: a malformed value would otherwise produce an invalid clip-path and
    // silently blank the layer rather than just misplacing it.
    var v = parseFloat(input.value);
    if (isNaN(v)) { return; }
    v = Math.max(0, Math.min(100, v));
    frame.style.setProperty('--dc-cmp-pos', v + '%');
  }

  function onInput(event) {
    var t = event.target;
    if (t && t.classList && t.classList.contains('dc-cmp__range')) {
      sync(t);
    }
  }

  // `input` fires for drag, click-to-jump AND keyboard; `change` is not needed on top of it.
  document.addEventListener('input', onInput);

  // Adopt whatever is already in the DOM. Liquid has written the start position inline, so this
  // only matters when a browser restores a previous slider value on soft navigation / reload.
  function scan(root) {
    (root || document).querySelectorAll('.dc-cmp__range').forEach(sync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }

  // Theme editor / Section Rendering API re-renders.
  document.addEventListener('shopify:section:load', function (event) {
    scan(event.target || document);
  });
})();
